import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from './messages';
import style from './style.module.less';
import { PromotionalBanner } from '../../../../../../components/promotional-banner';
import { InventoryApiUrl } from '../../../../../../constants/add-ons';

/**
 * TODO: [ENGINE-8782]: Remove this component
 * @returns {JSX.Element} The rendered component.
 */
export const OldPromotionalInventoryAddonBanner = () => (
  <PromotionalBanner
    className={style['settings-api-banner']}
    promotionalHeaderMessage={messages.title}
    promotionalSubheaderMessage={messages.content}
  >
    <Button className={style['settings-api-banner-button']} href={InventoryApiUrl} theme='promotional'>
      <FormattedMessage {...messages.button} />
    </Button>
  </PromotionalBanner>
);
